import { u as r } from "../styled-components.browser.esm-3eb04950.js";
const i = r.div`
    cursor: pointer;
    color: var(--primary);
`;
export {
  i as BironBreadCrumbTitle
};
//# sourceMappingURL=BironBreadCrumb.title.js.map
